import { PortalDialogProps } from "@app/services/modal.service";
import Modal from "../modal/modal.component";
import Button from "../button";
import { ImageCloud } from "@app/types";
import { useState } from "react";
import { addToast } from "../toast/toast.service";
import { formatMoneyVN } from "@app/utils/util";
import clsx from "clsx";
import useObservable from "@core/hooks/use-observable.hook";
import ImageCloudService from "@app/services/http/image.cloud.service";

interface AddHardwareModalProps {
  imageCloud: ImageCloud;
}

function AddHardwareModal({
  portalDialogRef,
  portalData,
}: PortalDialogProps<AddHardwareModalProps>) {
  const image = portalData?.imageCloud;
  const { subscribeOnce } = useObservable();
  const [hardwareListId, setHardwareListId] = useState<string[]>(
    image?.hardwares.map((hardware) => hardware._id) || []
  );

  if (!image || !image.cloud.hardwares?.length) {
    addToast({ text: "chưa có phần cứng" });

    return;
  }

  const handleChooseHardware = (id: string) => {
    if (hardwareListId.includes(id)) {
      setHardwareListId((pre) => {
        const index = hardwareListId.indexOf(id);

        pre.splice(index, 1);

        return [...pre];
      });
    } else {
      setHardwareListId((pre) => {
        return [...pre, id];
      });
    }
  };

  const handleSubmit = () => {
    subscribeOnce(
      ImageCloudService.addHarware(image._id, hardwareListId),
      () => {
        portalDialogRef.close({ isOk: true });
      }
    );
  };

  const renderStatusAddHardware = (accept: number) => {
    switch (accept) {
      case 1:
        return "Chưa yêu cầu thêm";
      case 2:
        return "Đang chờ";
      case 3:
        return "Thành Công";
      case 4:
        return "Thất bại";
    }
  };

  return (
    <Modal onCancel={portalDialogRef.close} buttonCancelInChildren>
      <div className="w-[350px] h-auto p-5">
        <div className="text-lg pr-8">Thêm phần cứng</div>

        <div className="">
          {image.cloud.hardwares.map((hardware) => {
            return (
              <div
                key={hardware._id}
                className={clsx("flex gap-2 bg-slate-400 rounded-sm p-1 my-1", {
                  "!bg-blue-600": hardwareListId.includes(hardware._id),
                })}
                onClick={() => handleChooseHardware(hardware._id)}
              >
                <p>{hardware.name}</p>
                <p>{formatMoneyVN(hardware.price)}đ</p>
              </div>
            );
          })}
        </div>
        {image.accepted_add_hardwares !== 1 && (
          <div className="my-2 text-blue-600">
            Trạng thái: {renderStatusAddHardware(image.accepted_add_hardwares)}
          </div>
        )}
        <div className="text-red-500 text-[12px]">
          Lưu ý:
          <br />
          - Yêu cầu thêm phần cứng chờ cập nhật.
          <br />- Chọn 1 hoặc cả 3 phần cứng cần thêm , không thể huỷ hoặc nâng
          thêm phần cứng khi trạng thái xác nhận thành công !
        </div>
        <div className="mt-4 flex justify-center gap-3">
          {[1, 2, 4].includes(image?.accepted_add_hardwares) ? (
            <Button
              size="xs"
              label="Đồng ý"
              width="fit-content"
              className="px-6 text-sm"
              labelClassName="font-bold"
              onClick={handleSubmit}
              // onClick={() => portalDialogRef.close({ isAccept: true })}
            />
          ) : (
            ""
          )}
          <Button
            size="xs"
            label="Đóng"
            theme="danger"
            width="fit-content"
            className="px-6 text-sm"
            labelClassName="font-bold"
            onClick={() => portalDialogRef.close()}
          />
        </div>
      </div>
    </Modal>
  );
}

export default AddHardwareModal;
